import { createSelector } from '@reduxjs/toolkit'

const getState = state => state.settings
const addons = state => getState(state).addons
const userSettings = state => getState(state).userSettings

export const getHasSalesforceAddon = state => addons(state).salesforce

export const getUsePersonalRoom = state => getState(state).usePersonalRoom

export const shouldHideUpcoming = state => getState(state).hideUpcoming

export const enableOnlyModerator = state => userSettings(state).enabledOnlyModerator
export const enableWaitForMe = state => userSettings(state).enabledWaitForMe

export const enableModerationSettings = state => enableWaitForMe(state) || enableOnlyModerator(state)

export const isOnlyModerator = state => userSettings(state).onlyModerator
export const shouldWaitForMe = state => userSettings(state).waitForMe

export const getEnabledGiphyIntegration = state => userSettings(state).enabledGiphyIntegration
export const getShowGiphyIntegration = state => userSettings(state).showGiphyIntegration

export const getShowSalesforceIntegration = state => userSettings(state).showSalesforceIntegration
export const getEnabledSalesforceIntegration = state => userSettings(state).enabledSalesforceIntegration

export const isDeepLinkingEnabled = state => userSettings(state).allowDesktopLaunch

export const isMeetingSharingEnabled = state => userSettings(state).allowMeetingSharing

export const getShowRecordingPrompt = state => userSettings(state).showRecordingPrompt

export const getHasSalesforceIntegration = createSelector(
  getShowSalesforceIntegration,
  getEnabledSalesforceIntegration,
  getHasSalesforceAddon,
  (showIntegration, isOverrideEnabled, hasAddon) => isOverrideEnabled ? hasAddon && showIntegration : hasAddon
)

export const getUseNewMeetingsExperience = state => getState(state).useNewMeetingsExperience

export const getHasMeetMetricsAccess = state => getState(state).hasMeetMetricsAccess
